import React, { useState, useEffect ,useRef} from 'react';
import { Form, Input, Button, Radio, Checkbox, Select, App, Modal } from 'antd';
import { QRCodeSVG } from 'qrcode.react'
import styles from './index.module.scss';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import { getUserCardList } from '@/api/card';
import { deliveryMethodOptionsMapper, orderStatusOptionsMapper } from '@/utils/constants';

import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import {
  getQrcode,
  createPrepaymentOrder,
  stripePay,
  boaPay,
  getOrderProductDataByProductIdList,
  getUserAddressList,
  saveOrderAddress,
  getOrderById,
  editSaveOrderAddress,
  editSaveOrderBillingAddress,
  saveOrderComplete,
  getOrderPaymentSuccessStatus,
  createFinalPaymentOrder
} from '@/api/order';
//使用国际化
import { useTranslation } from 'react-i18next';
import ComponentDialog from "@/components/ComponentDialog/ComponentDialog";
const { Option } = Select;
const PlaceOrderChild: React.FC = () => {
   
  // stripe支付对象
  const stripe = useStripe();
  // stripe支付元素
  const elements = useElements();

  // 定时器
  const intervalRef = useRef<any>(null);

  // 获取动态参数
  const useParamObj = useParams();

  // 获取查询参数
  const [searchParams] = useSearchParams();

  //国际化对象
  const { t } = useTranslation();

  const { message } = App.useApp();
  //跳转
  const navigate = useNavigate();

  // 是否是手机端
  const isMobile = useAppSelector((state) => state.searchBar.isMobile);

  // 支付方式 bank/stripe
  const [paymentMethod, setPaymentMethod] = useState('stripe');

  // 选择的银行卡
  const [selectedCard, setSelectedCard] = useState<number>(-1);

  // 银行卡列表
  const [bankCards, setBankCards] = useState<any[]>([
  ]);
  // 取货码区域显隐
  const [qrcodeShow, setQrcodeShow] = useState<boolean>(false)
  // 取货码二维码
  const [qrcode, setQrcode] = useState<string>('')
  // 取货码
  const [pickupCode, setPickupCode] = useState<string>('')
  //总价格
  const [totalPrice, setTotalPrice] = useState<number>(0);
    // 紧急程度
  const UrgencyLevel = useAppSelector((state) => state.common.UrgencyLevel);
  const [UrgencyLevelName, setUrgencyLevelName] = useState<string>('')
  //订单商品的ID组合，方便查询订单商品信息
  const [productsToOrder, setProductsToOrder] = useState<any[]>([]);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [mode, setMode] =
    React.useState<any>("bidding");
  const [currentInfo, setCurrentInfo] =
    React.useState<any | null>({
      title:'Auction Posted Successfully！',
      text:'Thanks for your payment. Please rate your experience to help us improve.',
      toPage:'View Order',
      isShowFooter: false,  // 默认不显示底部按钮
    });
  // stripe银行卡列表
  // const [stripeCards, setStripeCards] = useState<any[]>([
  // ]);

  // 修改收货地址表单
  const [formShippingAddress] = Form.useForm();

  // 修改账单地址表单
  const [formBillingAddress] = Form.useForm();

  // 订单备注
  const [orderRemarks, setOrderRemarks] = useState('');
  const [emergencyInfo, setEmergencyInfo] = useState<any>({});
  // 是否是同一地址
  const [sameAsShipping, setSameAsShipping] = useState(false);

  // 账单地址表单值
  const [billingAddressFormValues, setBillingAddressFormValues] = useState<any>({
    first_name: '',
    last_name: '',
    recipient_phone: '',
    email: '',
    extension: '',
    address: '',
    building: '',
    zip_code: '',
    city: '',
    state: '',
  });

  // stripe 卡号 + 有效期 + CVC 都填完时为 true
  const [cardComplete, setCardComplete] = useState(false);

  // 是否在支付中
  const [isPaymenting, setIsPaymenting] = useState(false);

  const [btnText, setBtnText] = useState(t('PlaceOrderChild1.SubmitOrder'));

  const handleCardChange = (event: any) => {
    setCardComplete(event.complete); // 卡号 + 有效期 + CVC 都填完时为 true
  };

  //勾选账单地址和收货地址是同一个地址
  const SameAsShippingAddress = (checked: boolean) => {

    // 勾选账单地址和收货地址是同一个地址
    if (checked && selectedShippingAddressIndex !== -1 && shippingAddressSource.length > 0) {
      // 获取收货地址
      const shippingAddress = JSON.parse(JSON.stringify(shippingAddressSource[selectedShippingAddressIndex]));
      delete shippingAddress.is_default;
      delete shippingAddress.id;

      setBillingAddressFormValues({ ...shippingAddress });

      formBillingAddress.setFieldsValue({
        ...shippingAddress
      });

      // 取消勾选清空账单地址自己填
    } else {

      const obj = {
        first_name: '',
        last_name: '',
        recipient_phone: '',
        email: '',
        extension: '',
        address: '',
        building: '',
        zip_code: '',
        city: '',
        state: '',
      };
      // 清空账单地址
      formBillingAddress.setFieldsValue(obj);
      // 清空账单地址表单值
      setBillingAddressFormValues(obj);
    }


    setSameAsShipping(checked);
  }



  //展开收起 默认收起false
  const [isShowMore, setIsShowMore] = useState(false);

  // 是否是弹窗
  const [isModalOpen, setIsModalOpen] = useState(false);



  // 编辑账单地址
  const [isEditBillingAddress, setIsEditBillingAddress] = useState(false);
  const [editShippingAddress, setEditShippingAddress] = useState<any>(null);
  const [tempBillingAddress, setTempBillingAddress] = useState<any>({});

  // 判断是编辑当前地址还是编辑订单的地址
  const [isEditOrderAddress, setIsEditOrderAddress] = useState(false);
  const handleConfirm = () => {
    console.log('确认');
    setDialogOpen(false);    
  };
  const onNavigate = () => {
    console.log('确认');
    navigate(`/yourtownloop/postorders`);   
  };

  // 订单提交
  const handleSubmitOrder = () => {
    // 收货地址列表为空
    if (shippingAddressSource.length == 0) {
      message.error(t("PlaceOrderChild1.shippingaddressfirst"));
      return;
    }

    // 没有选择收货地址
    if (selectedShippingAddressIndex == -1) {
      message.error(t("PlaceOrderChild1.selectshippingaddress"));
      return;
    }

    const billingAddressFormValuesKeys = Object.keys(billingAddressFormValues);

    // 账单地址为空
    for (let i = 0; i < billingAddressFormValuesKeys.length; i++) {

      const key = billingAddressFormValuesKeys[i];

      // extension和building不必填，不需要校验
      if (!billingAddressFormValues[key] && key != 'extension' && key != 'building') {
        // 账单地址为空
        message.error(t("PlaceOrderChild1.completebillingaddress"));
        return;
      }
    }


    // if (paymentMethod === 'bank' && selectedCard == -1) {
    //   message.error('Please select a card');
    //   return;
    // }


    //当前选中的收货地址
    const shippingAddress = shippingAddressSource[selectedShippingAddressIndex];

    const params = {
      // 商品列表 这里假数据，到时候再改
      // [{product_id:'PROD',product_sku_id:'SN',quantity:1}]
      // product_list: productsToOrder.map((item) => ({
        
      //   // product_id: item.product_id,
      //   // product_sku_id: item.product_sku_id,
      //   // product_item_quantity: item.quantity,
      //   // cart_id: item.cart_id,
      // })),
      emergency_service_id: emergencyInfo.emergency_service_id,
      //支付方式
      payment_method: paymentMethod === 'bank' ? 1 : 2,
      //银行卡id - 只有bank支付方式才需要
      // ...(paymentMethod === 'bank' && { card_id: selectedCard }),
      // 收货地址
      // order_address: {
      //   email: shippingAddress.email,
      //   recipient_phone: shippingAddress.recipient_phone,
      //   address: shippingAddress.address,
      //   zip_code: shippingAddress.zip_code,
      //   city: shippingAddress.city,
      //   state: shippingAddress.state,
      //   first_name: shippingAddress.first_name,
      //   last_name: shippingAddress.last_name,
      //   building: shippingAddress.building,
      //   extension: shippingAddress.extension,

      // },
      // 账单地址
      order_billing_address: {
        email: billingAddressFormValues.email,
        recipient_phone: billingAddressFormValues.recipient_phone,
        address: billingAddressFormValues.address,
        zip_code: billingAddressFormValues.zip_code,
        city: billingAddressFormValues.city,
        state: billingAddressFormValues.state,
        first_name: billingAddressFormValues.first_name,
        last_name: billingAddressFormValues.last_name,
        building: billingAddressFormValues.building,
        extension: billingAddressFormValues.extension,
      },
      //备注
      order_remarks: orderRemarks
    };
    let api:any;
    if(emergencyInfo.status === 5) {
      api = createFinalPaymentOrder;
    }else{
      api = createPrepaymentOrder;
    }
    api(params).then((res:any) => {
      if (res.code == 200) {
        const orderData = res.data;
        //debugger
        if (paymentMethod == 'bank') {

          // 美国银行支付
          _PostBoaPay(shippingAddress, orderData);

        } else if (paymentMethod == 'stripe') {

          //stripe支付
          _PostStripePay(orderData);
        }
      } else {
        message.error(res.msg);
      }


    });
    // 这里可以处理订单提交逻辑
  };


  //未支付状态下再次发起支付
  const PayAgain = () => {

    if(!orderDetailData.product_order){

      return;
    }
    //当前选中的收货地址
    const shippingAddress = shippingAddressSource[selectedShippingAddressIndex];

    const orderData = {
      order_total_price:orderDetailData?.product_order?.product_order_total_price,
      order_id:orderDetailData?.product_order?.product_order_id,
      user_id:orderDetailData?.product_order?.user?.user_id
    };
    if(paymentMethod == 'bank'){
      _PostBoaPay(shippingAddress, orderData);
    }else if(paymentMethod == 'stripe'){
      _PostStripePay(orderData);
    }
  }
  // 美国银行支付
  const _PostBoaPay = (shippingAddress: any, orderData: any) => {
    const bankParams = {
      amount: Number(orderData.order_total_price),
      bill_to_address_city:
        shippingAddress.city || billingAddressFormValues.city || "",
      bill_to_address_country: "US",
      bill_to_address_line1:
        shippingAddress.address || billingAddressFormValues.address || "",
      bill_to_address_line2: "",
      bill_to_address_postal_code:
        shippingAddress.zip_code || billingAddressFormValues.zip_code || "",
      bill_to_address_state:
        shippingAddress.state || billingAddressFormValues.state || "",
      bill_to_company_name: "",
      bill_to_email: shippingAddress.email || billingAddressFormValues.email || "",
      bill_to_forename:
        shippingAddress.first_name || billingAddressFormValues.first_name || "",
      bill_to_phone: shippingAddress.recipient_phone || billingAddressFormValues.recipient_phone || "",
      bill_to_surname:
        shippingAddress.last_name || billingAddressFormValues.last_name || "",
      order_id: orderData.order_id,
    };

    boaPay(bankParams).then((res) => {
      //console.log(res, 'res');
      if (res.code == 200) {
        const boaData = res.data;
        const forms = document.createElement("form");
        forms.action = process.env.REACT_APP_BOA_PAY_URL || "";
        forms.method = "POST";
        forms.style.display = "none";
        for (let key in boaData) {
          let input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = boaData[key];
          forms.appendChild(input);
        }
        document.body.appendChild(forms);
        forms.submit();
        document.body.removeChild(forms);
      } else {
        message.error(res.msg);
      }
    });

  }
  // 美国stripe支付
  const _PostStripePay = async (orderData: any) => {
    if (!stripe || !elements) return;
    setIsPaymenting(true);
    setBtnText('Paying...');
    // 创建一个 AbortController 实例，可以取消请求
    const controller = new AbortController();
    const signal = controller.signal;

    const stripeParams = {
      order_total_price: Number(orderData.order_total_price),
      user_id: orderData.user_id,
      order_id: orderData.order_id,
      email: billingAddressFormValues.email,
      phone: billingAddressFormValues.recipient_phone,
      name: billingAddressFormValues.first_name + " " + billingAddressFormValues.last_name,
      addr: billingAddressFormValues.address,
      payment_type: "stripe",
      signal: signal, // 传递 signal 给请求
    };

    const request = stripePay(stripeParams);

    const timeout = new Promise((_, reject) => {
      setTimeout(() => {
        reject(new Error(
          'The server is busy and try again later'
        ));
      }, 10000); // 10 秒超时
    });

    try {
      const res = await Promise.race([request, timeout]);
      //console.log(res, 'stripePay res');

      if (!!res && res.code == 200) {
        //debugger
        const clientSecret = res.data.clientSecret;



        //支付调用
        const result = await stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: elements.getElement(CardElement)!,
            billing_details: {
              name: stripeParams.name,
              email: stripeParams.email,
              phone: stripeParams.phone,
              address: {
                line1: stripeParams.addr,
              },
            },
          },
        });

        //console.log('result', result);
        

        if (result.error) {

          setIsPaymenting(false);
          setBtnText(t("PlaceOrderChild1.Submitorder"));
          message.error(result.error.message || t("PlaceOrderChild1.Paymenterror"));

        } else if (result.paymentIntent?.status === 'succeeded') {

          const actionInterval = async ()=>{
            intervalRef.current = setInterval(async() => {
              const res2 = await getOrderPaymentSuccessStatus(orderData.order_id);
              if (res2.code == 200) {
  
  
                if(res2.data == true){
  
                  clearInterval(intervalRef.current);
  
                  setIsPaymenting(false);
                  setBtnText(t("PlaceOrderChild1.Submitorder"));
                  message.success(t("PlaceOrderChild1.Paymentsuccessful"));
                  // TODO: 页面跳转、刷新订单状态等
                  setDialogOpen(true);  
  
                }
                
              }
            }, 2000);
          }

           getOrderPaymentSuccessStatus(orderData.order_id).then((res2)=>{
              if (res2.code == 200) {
                if(res2.data == true){
                  clearInterval(intervalRef.current);
                  setIsPaymenting(false);
                  setBtnText(t("PlaceOrderChild1.Submitorder"));
                  message.success(t("PlaceOrderChild1.Paymentsuccessful"));
                  setDialogOpen(true);  
                }else{
                  actionInterval();
                }
                
              }
           }).catch((error)=>{
              console.error(error, 'error');
              actionInterval();
           });




        }

      } else {
        setIsPaymenting(false);
        setBtnText(t("PlaceOrderChild1.Submitorder"));
      }
    } catch (error: any) {
      message.error(error.message);
      setIsPaymenting(false);
      setBtnText(t("PlaceOrderChild1.Submitorder"));
      controller.abort(); // 取消请求

    }
  }

  //美国州列表
  const StateList = useAppSelector((state) => state.common.StateList);

  //打开收货地址新增
  const showModal = () => {
    //给表单回传默认值
    formShippingAddress.setFieldsValue({
      id: '',
      first_name: '',
      last_name: '',
      recipient_phone: '',
      email: '',
      extension: '',
      address: '',
      building: '',
      zip_code: '',
      city: '',
      state: '',
      is_default: false,
    });
    setIsModalOpen(true);
  };
  //收货地址提交表单
  const handleOk = async () => {
    try {
      const values = await formShippingAddress.validateFields();
      if (isEditOrderAddress) {
        // 编辑订单地址，调用editSaveOrderAddress
        const response = await editSaveOrderAddress({
          order_id: orderDetailData?.product_order?.product_order_id,
          order_billing_address: orderDetailData.product_order_billing_address || {},
          order_address: values
        });

        if (response.code === 200) {
          message.success(t("PlaceOrderChild1.Orderupdatedsuccessfully"));
          // 重新获取订单详情
          if (orderDetailData?.product_order?.product_order_id) {
            const orderResponse = await getOrderById(orderDetailData?.product_order?.product_order_id);
            if (orderResponse.code === 200) {
              setOrderDetailData(orderResponse.data);
            }
          }
        } else {
          message.error(response.msg || t("PlaceOrderChild1.Failedupdateaddress"));
        }
      } else {
        // 编辑现有地址，调用saveOrderAddress
        const res = await saveOrderAddress({
          ...values,
        });

        if (res.code == 200) {
          message.success(t("PlaceOrderChild1.Addresssavedsuccessfully"));
          getUserAddressListData();
        } else {
          message.error(res.msg);
        }
      }

      setIsModalOpen(false);
      setIsEditOrderAddress(false);
    } catch (error) {
      console.error('Error saving address:', error);
      message.error(t("PlaceOrderChild1.Failedsaveaddress"));
    }
  };

  //取消收货地址表单
  const handleCancel = () => {
    setIsModalOpen(false);
    setIsEditOrderAddress(false);
    setEditShippingAddress(null);
  };

  // 保存账单地址
  const handleSaveBillingAddress = async () => {
    try {
      const currentFormValues = formBillingAddress.getFieldsValue();
      // 更新账单地址
      const updatedStagedAddress = {
        ...(tempBillingAddress || {}),
        ...currentFormValues
      };
      setTempBillingAddress(updatedStagedAddress);

      // 保存账单地址
      const response = await editSaveOrderBillingAddress({
        order_id: orderDetailData?.product_order?.product_order_id,
        order_billing_address: updatedStagedAddress
      });

      if (response.code === 200) {
        message.success(t("PlaceOrderChild1.Billingupdatedsuccessfully"));
        // 重新获取订单详情
        if (orderDetailData?.product_order?.product_order_id) {
          const orderResponse = await getOrderById(orderDetailData?.product_order?.product_order_id);
          if (orderResponse.code === 200) {
            setOrderDetailData(orderResponse.data);
          }
        }
      } else {
        message.error(response.message || t("PlaceOrderChild1.Failedtoupdateaddress"));
      }

      setIsEditBillingAddress(false);
    } catch (error) {
    }
  };

  // 选择的收货地址
  const [selectedShippingAddressIndex, setSelectedShippingAddressIndex] = useState<number>(0);

  const selectShippingAddress = (index: number) => {
    setSelectedShippingAddressIndex(index);
    if (sameAsShipping) {
      const shippingAddress = JSON.parse(JSON.stringify(shippingAddressSource[index]));
      delete shippingAddress.is_default;
      delete shippingAddress.id;
      formBillingAddress.setFieldsValue({
        ...shippingAddress
      });
    }
  }

  // 收货地址地址列表数据（shipping address）
  const [shippingAddressSource, setShippingAddressSource] = useState<any[]>([
    // { 
    //   "id": "", 
    //   "first_name": "jin", 
    //   "last_name": "tao", 
    //   "recipient_phone": "17366211230", 
    //   "email": "494313281@qq.com", 
    //   "extension": "1234", 
    //   "address":"address", 
    //   "building": "building", 
    //   "zip_code": "90037", 
    //   "city": "南京", 
    //   "state": "AL", 
    //   "is_default": true 
    // }


  ]);

  // 订单的商品信息列表
  const [orderProductData, setOrderProductData] = useState<any[]>([]);

  // 订单详情数据
  const [orderDetailData, setOrderDetailData] = useState<any>(null);

  // 检查是否为待支付状态
  const isPendingPayment = orderDetailData?.product_order?.product_order_status === 1;


  // 获取用户收货地址列表
  const getUserAddressListData = () => {
    getUserAddressList().then((res) => {
      if (res.code == 200) {
        setShippingAddressSource(res.data);
      }
    });
  }


  // 正确使用Form.useWatch - 必须在组件顶层调用
  const billingFormValues = Form.useWatch([], formBillingAddress);

  // 监听表单值变化
  useEffect(() => {

    if (billingFormValues) {

      const keys = Object.keys(billingFormValues);

      const obj: any = {};

      keys.forEach(key => {
        obj[key] = billingFormValues[key] == undefined ? '' : billingFormValues[key];
      });

      setBillingAddressFormValues({ ...obj });
    }
  }, [billingFormValues]);

  //计算总价
  useEffect(() => {
    setTotalPrice(orderProductData.reduce((acc, item) => acc + Number(item.total_price), 0));
  }, [orderProductData])

  //mounted
  useEffect(() => {
    if (searchParams.get('products_to_order')) {
      const emergencyInfoStr = localStorage.getItem('emergency_service_info');
      let emergencyInfo: any = null;
      try {
        emergencyInfo = emergencyInfoStr ? JSON.parse(emergencyInfoStr) : null;
      } catch (err) {
        console.warn('Invalid emergency_service_info in localStorage', err);
        emergencyInfo = null;
      }
      setEmergencyInfo(emergencyInfo);
      if(emergencyInfo.status===2 || emergencyInfo.status===5){
        setCurrentInfo((prev:any) => ({
          ...prev,
          isShowFooter: true
        }));
      }
      const obj:any = UrgencyLevel.find(item => item.value === emergencyInfo?.urgency_level)
      setUrgencyLevelName(obj?.label)
      const productsToOrder = JSON.parse(atob(searchParams.get('products_to_order') || ''));

      setProductsToOrder(productsToOrder);

      // 获取订单商品信息
      getOrderProductDataByProductIdList({
        product_list: productsToOrder,
      }).then((res) => {
        if (res.code == 200) {
          setOrderProductData(res.data);
        }

      });


      // 获取银行卡列表
      getUserCardList().then((res) => {
        if (res.code == 200) {
          setBankCards(res.data);
        }
      });

    }

    // 获取用户收货地址列表 - 当有orderId参数时不调用
    const encodedOrderId = searchParams.get('orderId');
    if (!encodedOrderId) {
      getUserAddressListData();
    } else {
      if (isPendingPayment) {
        getUserAddressListData();
      }
    }
  }, []);

  // 处理从Order Details跳转过来的订单详情
  useEffect(() => {
    const encodedOrderId = searchParams.get('orderId');
    if (encodedOrderId) {
      // 解码订单ID
      const orderId = atob(encodedOrderId);
      //console.log('从Order Details跳转过来，订单ID:', orderId);
      // 获取二维码以及取货码
      getQrcode({order_id: orderId}).then(res => {
        if(res.code === 200) {
          setQrcode(res.data.qr_code_file_url);
          setPickupCode(res.data.pickup_code);
        }
      })

      // 调用getOrderById接口获取订单详情
      getOrderById(orderId).then((res) => {
        //console.log('getOrderById接口返回数据:', res);
        if (res.code === 200) {
          //console.log('订单详情数据:', res.data);
          setOrderDetailData(res.data); // 设置订单详情数据
          setQrcodeShow(res.data.product_order.product_order_status === 3)//设置取货二维码是否显示(订单状态为3的时候显示)
          // 设置订单商品数据
          if (res.data.product_order_items && res.data.product_order_items.length > 0) {
            const transformedOrderItems = res.data.product_order_items.map((item: any) => ({
              product_data: item.product,
              product_sku_data: item.product_sku,
              total_price: (Number(item.product_item_price) * Number(item.product_item_quantity)).toFixed(2),
              product_item_quantity: item.product_item_quantity
            }));
          
            setOrderProductData(transformedOrderItems);
            const productsToOrderFromOrderItems = res.data.product_order_items.map((item: any) => {
              // 从订单详情跳转过来 还是从购物车跳转过来的
              const productId = item.product_id || item.product?.product_id;
              const productSkuId = item.product_sku_id || item.product_sku?.product_sku_id;
              return {
                product_id: productId,
                product_sku_id: productSkuId,
                quantity: item.product_item_quantity
              };
            });
            setProductsToOrder(productsToOrderFromOrderItems);
          }
          // 设置收货地址数据
          if (res.data.order_address) {
            const shippingAddress = res.data.order_address;
            const addressData = {
              id: shippingAddress.order_address_id,
              first_name: shippingAddress.first_name,
              last_name: shippingAddress.last_name,
              recipient_phone: shippingAddress.recipient_phone,
              email: shippingAddress.email,
              extension: shippingAddress.extension,
              address: shippingAddress.address,
              building: shippingAddress.building,
              zip_code: shippingAddress.zip_code,
              city: shippingAddress.city,
              state: shippingAddress.state,
              is_default: false
            };
            setShippingAddressSource([addressData]);
            setSelectedShippingAddressIndex(0);
          }
        } else {
          console.error('获取订单详情失败:', res.message);
        }
      }).catch((error) => {
        console.error('调用getOrderById接口失败:', error);
      });
    }
  }, [searchParams]);

  // 当有订单详情时，回显账单地址数据和支付方式
  useEffect(() => {
    if (orderDetailData) {
      // 回显订单备注
      if (orderDetailData.product_order && orderDetailData.product_order.product_order_remarks) {
        setOrderRemarks(orderDetailData.product_order.product_order_remarks);
      }

      // 回显账单地址数据
      if (orderDetailData.product_order_billing_address) {
        const billingAddress = orderDetailData.product_order_billing_address;
        const billingFormData = {
          first_name: billingAddress.first_name || '',
          last_name: billingAddress.last_name || '',
          recipient_phone: billingAddress.recipient_phone || '',
          email: billingAddress.email || '',
          extension: billingAddress.extension || '',
          address: billingAddress.address || '',
          building: billingAddress.building || '',
          zip_code: billingAddress.zip_code || '',
          city: billingAddress.city || '',
          state: billingAddress.state || '',
        };
        formBillingAddress.setFieldsValue(billingFormData);
        setBillingAddressFormValues(billingFormData);
      }

      // 更新收货地址数据 
      if (orderDetailData.product_order_address) {
        const shippingAddress = orderDetailData.product_order_address;
        const addressData = {
          id: shippingAddress.order_address_id,
          first_name: shippingAddress.first_name,
          last_name: shippingAddress.last_name,
          recipient_phone: shippingAddress.recipient_phone,
          email: shippingAddress.email,
          extension: shippingAddress.extension,
          address: shippingAddress.address,
          building: shippingAddress.building,
          zip_code: shippingAddress.zip_code,
          city: shippingAddress.city,
          state: shippingAddress.state,
          is_default: false
        };
        setShippingAddressSource([addressData]);
        setSelectedShippingAddressIndex(0);
      }

      // 设置支付方式
      if (orderDetailData.product_order && orderDetailData.product_order.product_order_payment_method) {


        setPaymentMethod(orderDetailData.product_order.product_order_payment_method == 1 ? 'bank' : 'stripe');
      }

      // 待支付状态加载银行卡
      if (isPendingPayment && bankCards.length === 0) {
        getUserCardList().then((res) => {
        
          if (res.code == 200) {
            setBankCards(res.data);
          }
        });
      }
    }
  }, [orderDetailData, isPendingPayment]);

  // 卸载时清除定时器
  useEffect(() => {
    return () => {
      clearInterval(intervalRef.current);
    }
  }, []);

  return (
    <div className={styles['order-container']}>
      <h1 className={styles['page-title']}>
        Confirm bidding order
      </h1>
      <div className={styles['order-content']}>
        <div className={styles['order-main']}>
          {/* 确认订单信息-订单列表 */}
          <div className={styles['order-section']}>
            {/* <h2 className={styles['section-title']}>{t("PlaceOrderChild1.Confirmorderinformation")}</h2> */}

            <div className={styles['product-section']}>
              {/* <h3 className={styles['shop-title']}>{t("PlaceOrderChild1.BasketBonanza")}</h3> */}
              <div className={styles['page-title-in']}>Confirm order information</div>
              <div className={styles['order-table']}>
                <div className={styles['table-header']}>
                  <div className={styles['header-item']}>Order Information</div>
                  <div className={styles['header-item']}>Urgency Level</div>
                  <div className={styles['header-item']}>Push Fee</div>
                  <div className={styles['header-item']}>Starting Bid</div>
                </div>

                {
                  orderProductData.map((item, index) => {
                    return (
                      <div className={styles['product-item']} key={index}>
                        <div className={styles['item-col']}>
                          <div className={styles['product-info']}>
                            <img
                              src={emergencyInfo.images[0].product_media_file_url}
                              alt="Product"
                              className={styles['product-image']}
                            />
                            <div className={styles['product-details']}>
                              <div className={styles['product-name']}>Appliance Repair</div>
                              <div className={styles['miles-row']}>
                                <span className={styles['dot']}></span>
                                {emergencyInfo.distance || 2.5} Miles From You
                              </div>
                              <div className={styles['product-text']}>Remaining Bidding Time: {emergencyInfo.create_time}&nbsp;minutes</div>
                              <div className={styles['product-text']}>Remaining Bidding Time: {emergencyInfo.problem_description}</div>
                              {/* <div className={styles['payment-method']}>Pay By Credit Card</div> */}
                            </div>
                          </div>
                        </div>
                        <div className={styles['item-col']}>
                          <div className={styles['product-attrs']}>
                           {UrgencyLevelName}
                          </div>
                        </div>
                        <div className={styles['item-col']}>
                          <div className={styles['price']}>${emergencyInfo.push_fee}</div>
                        </div>

                        <div className={styles['item-col']}>
                          <div className={styles['total-price']}>${emergencyInfo.push_fee+emergencyInfo.prepayment_total}</div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
              <div className={styles['order-remarks']}>
                <div className={styles['remarks-title']}>{t("PlaceOrderChild1.Orderremarks")}</div>
                <Input.TextArea
                  value={orderDetailData ? (orderDetailData.product_order?.product_order_remarks || '') : orderRemarks}
                  onChange={(e) => {
                    setOrderRemarks(e.target.value);
                    // 如果有订单详情数据，同步更新到订单详情中
                    if (orderDetailData && orderDetailData.product_order) {
                      setOrderDetailData({
                        ...orderDetailData,
                        product_order: {
                          ...orderDetailData.product_order,
                          product_order_remarks: e.target.value
                        }
                      });
                    }
                  }}
                  placeholder={orderDetailData ? '' : t('PlaceOrderChild1.Pleaseenterorderremarks')}
                  className={styles['remarks-input']}
                  maxLength={200}
                  disabled={orderDetailData && !isPendingPayment}
                />
                {!orderDetailData && <div className={styles['char-count']}>0/200</div>}
                {orderDetailData && orderDetailData.product_order && orderDetailData.product_order.product_order_status === 0 && <div className={styles['char-count']}>0/200</div>}
              </div>
            </div>
          </div>
          {/* 确认订单信息-订单列表 */}

          
          {/* 选择收货地址 */}

          {/* 填写账单地址 */}
          <div className={styles['order-section']}>
            <div className={styles['section-header']}>
              <h2 className={styles['section-title']}>{t("PlaceOrderChild1.BillingAddress")}</h2>
              {orderDetailData && orderDetailData.product_order && orderDetailData.product_order.product_order_status === 3 && (
                <div className={styles['address-actions']}>
                  <span
                    className={styles['action-link']}
                    onClick={() => setIsEditBillingAddress(!isEditBillingAddress)}
                  >
                    {isEditBillingAddress ? t('common.Cancel') : t('common.Confirm')}
                  </span>
                </div>
              )}
            </div>

            <div className={styles['billing-form']}>
              <Form
                form={formBillingAddress}
                layout="vertical"
                disabled={orderDetailData && !isPendingPayment && !isEditBillingAddress}
              >
                <div className={styles['form-row']}>
                  <Form.Item
                    label={t('membershipChild.FirstName')}
                    name="first_name"
                    required
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={t('membershipChild.LastName')}
                    name="last_name"
                    required
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={t('membershipChild.Phone')}
                    name="recipient_phone"
                    required
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>
                </div>
                <div className={styles['form-row']}>
                  <Form.Item
                    label={t('membershipChild.Email')}
                    name="email"
                    required
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={t('membershipChild.Extension')}
                    name="extension"
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>
                </div>

                <div className={styles['form-row']}>
                  <Form.Item
                    label={t('membershipChild.Address')}
                    name="address"
                    required
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={t('membershipChild.AptBuilding')}
                    name="building"
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>
                </div>

                <div className={styles['form-row']}>
                  <Form.Item
                    label={t('membershipChild.ZipCode')}
                    name="zip_code"
                    required
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>
                </div>

                <div className={styles['form-row']}>
                  <Form.Item
                    label={t('membershipChild.City')}
                    name="city"
                    required
                    className={styles['form-item']}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label={t('membershipChild.State')}
                    name="state"
                    required
                    className={styles['form-item']}
                  >
                    <Select>
                      {
                        StateList.map((item, index) => (
                          <Option value={item.value} key={index}>{item.label}</Option>
                        ))
                      }

                    </Select>
                  </Form.Item>
                </div>
                {(!orderDetailData || isPendingPayment) && (
                  <div className={styles['form-row']}>
                    <Checkbox
                      checked={sameAsShipping}
                      onChange={(e) => SameAsShippingAddress(e.target.checked)}
                      className={styles['same-address-checkbox']}

                    >
                      {t("PlaceOrderChild1.SameAsShippingAddress")}
                    </Checkbox>
                  </div>
                )}

                {orderDetailData && orderDetailData.product_order && orderDetailData.product_order.product_order_status === 3 && isEditBillingAddress && (
                  <div className={styles['form-row']}>
                    <Button
                      type="primary"
                      onClick={handleSaveBillingAddress}
                      className={styles['save-address-btn']}
                    >
                      {t("PlaceOrderChild1.SaveBillingAddress")}
                    </Button>
                  </div>
                )}
              </Form>
            </div>
          </div>
          {/* 填写账单地址 */}
        </div>

        {/* 支付提交 */}
        <div className={styles['order-sidebar']}>
          <div className={styles['payment-details']}>
            {qrcodeShow && (<div className={styles['pickup-info']}>
              <div className={styles['sidebar-title']}>{t('PlaceOrderChild1.PickupInformation')}</div>
              <div className={styles['pickup-info-mark']}>{t('PlaceOrderChild1.qrcodeMark')}</div>
              <div className={styles['pickup-code-row']}>
                <div className={styles['pickup-title']}>{t('PlaceOrderChild1.PickupCode')}</div>
                <div className={styles['pickup-code']}>{pickupCode}</div>
              </div>
              <div className={styles['qrcode-wrap']}>
                <QRCodeSVG className={styles['qrcode-wrap']} value={qrcode} size={127}/>
              </div>
            </div>)}
            <div className={styles['sidebar-box']}>
              <div className={styles['sidebar-title']}>{t("PlaceOrderChild1.Paymentdetails")}</div>
              {/* <div className={styles['total-info']}>{t("PlaceOrderChild1.Total")}
                <span style={{ color: '#0D323E', fontWeight: 'bold' }}> {orderProductData.length} </span> 
                {t('PlaceOrderChild1.Items')} 
              </div> */}
            </div>
            {
              emergencyInfo.status === 5 ? (
                <>
                  <div className={styles['price-row']}>
                    <span>Winning Bid</span>
                    <span className={styles['price']}>${emergencyInfo.budget}</span>
                  </div>

                  <div className={styles['price-row']}>
                    <span>Push Fee</span>
                    <span className={styles['discount']}>${emergencyInfo.push_fee}</span>
                  </div>
                  <div className={styles['price-row']}>
                    <span>Amount Paid</span>
                    <span className={styles['discount']}>${emergencyInfo.deposit_amount}</span>
                  </div>   
                </>            
              ) : (
                <>
                  <div className={styles['price-row']}>
                    <span>Starting Bid</span>
                    <span className={styles['price']}>${emergencyInfo.budget}</span>
                  </div>

                  <div className={styles['price-row']}>
                    <span>Prepayment (20%)</span>
                    <span className={styles['discount']}>${emergencyInfo.prepayment_total}</span>
                  </div>
                  <div className={styles['price-row']}>
                    <span>Push Fee</span>
                    <span className={styles['discount']}>${emergencyInfo.push_fee}</span>
                  </div>   
                </> 
              )
            }

            {(!orderDetailData || (orderDetailData && isPendingPayment)) && (
              <div className={styles['payment-method']}>
                <div className={styles['method-title']}>{t("PlaceOrderChild1.Paymentmethod")}</div>

                <div className={styles['payment-options']}>
                  {/* 支付方式 */}
                  <div className={styles['payment-option']}>
                    <Radio.Group
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      disabled={orderDetailData && !isPendingPayment}
                    >
                      <Radio value="stripe" className={styles['payment-radio']}>{t("PlaceOrderChild1.Stripe")}</Radio>
                      <Radio value="bank" className={styles['payment-radio']}>{t("PlaceOrderChild1.Boat")}</Radio>
                    </Radio.Group>
                  </div>
                  {/* 银行卡bank */}
                  {/* {paymentMethod === 'bank' &&  (
                    <Radio.Group
                      value={selectedCard}
                      onChange={(e) => setSelectedCard(e.target.value)}
                      disabled={orderDetailData && !isPendingPayment}
                    >
                      {bankCards.map(card => (
                        <div className={styles['bank-card-option']} key={card.id}>
                          <Radio value={card.id} className={styles['card-radio']}>
                            <div className={styles['bank-card']}>
                              {
                                card.bank_name == 'Visa' ?
                                  <img src={icon5} alt="Bank" className={styles['bank-icon']} />
                                  : card.bank_name == 'Discover' ?
                                    <img src={icon6} alt="Bank" className={styles['bank-icon']} />
                                    : card.bank_name == 'Mastercard' ?
                                      <img src={icon8} alt="Bank" className={styles['bank-icon']} />
                                      : card.bank_name == 'American express' ?
                                        <img src={icon7} alt="Bank" className={styles['bank-icon']} />
                                        : ''

                              }
                              <div className={styles['bank-info']}>
                                <div>{card.name}</div>
                                <div className={styles['card-number']}>{card.card_number}</div>
                              </div>
                            </div>
                          </Radio>
                        </div>
                      ))}
                    </Radio.Group>
                  )} */}
                  {/* stripe支付 */}
                  {paymentMethod === 'stripe' && (
                    <div style={{ margin: '20px 0', opacity: (orderDetailData && !isPendingPayment) ? 0.5 : 1 }}>
                      <CardElement
                        onChange={handleCardChange}
                        options={{
                          style: {
                            base: {
                              fontSize: '16px',
                              color: '#32325d',
                              '::placeholder': {
                                color: '#aab7c4',
                              },
                            },
                            invalid: {
                              color: '#fa755a',
                            },
                          },
                        }}
                      />
                      <div style={{ marginTop: '10px', color: cardComplete ? '#008000' : '#ff0000' }}>
                        {cardComplete ? t('membershipChild.CardComplete')  : t('membershipChild.PleaseFillInAllCardDetails')}
                      </div>
                    </div>
                  )}



                </div>
              </div>
            )}
            <div className={styles['actual-payment']}>
              <span>{t("PlaceOrderChild1.Actualpayment")}</span>
              <span className={styles['total-price']}>${emergencyInfo.budget-(emergencyInfo.deposit_amount+emergencyInfo.push_fee)}</span>
            </div>
            {/* 订单信息 */}
            {orderDetailData && orderDetailData.product_order && orderDetailData.product_order.product_order_status !== 1 && (
              <div className={styles['order-info']}>
                <div className={styles['order-info-title']}>
                 {t("PlaceOrderChild1.Orderinformation")}
                </div>
                <div>
                  <span>{t("PlaceOrderChild1.Ordernumber")}</span>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span className={styles['order-id']}></span>
                    <span
                      className={styles['copy-btn']}
                      onClick={() => {
                        navigator.clipboard.writeText(orderDetailData.product_order.product_order_id);
                        message.success('Copied to clipboard');
                      }}
                    >
                      {t("PlaceOrderChild1.Copy")}
                    </span>
                  </div>
                </div>
                <div>
                  <span>{orderDetailData.product_order.product_order_id}</span>
                </div>
                <div>
                  <span>{t("PlaceOrderChild1.Paymentmethod")}</span>
                  <span className={styles['order-id']}>{orderDetailData.product_order.product_order_payment_method == 1 ? 'bank' : 'stripe'}</span>
                </div>
                <div>
                  <span>{t("PlaceOrderChild1.Creationtime")}</span>
                  <span className={styles['order-id']}>{orderDetailData.product_order.created_time}</span>
                </div>
                <div>
                  <span>{t("PlaceOrderChild1.Paymenttime")}</span>
                  <span className={styles['order-id']}>{orderDetailData.product_order.update_time}</span>
                </div>
                <div>
                  <span>{t("PlaceOrderChild1.Orderstatus")}</span>
                  <span className={styles['order-id']}>{orderStatusOptionsMapper().find(item => item.value === orderDetailData.product_order.product_order_status)?.label}</span>
                </div>
                {/* <div>
                  <span>Delivery date</span>
                  <span className={styles['order-id']}>
                    {orderDetailData.product_order_items && orderDetailData.product_order_items[0]?.product_sku?.product?.delivery_estimated_time || orderDetailData.product_order.delivery_estimated_time || 'N/A'}
                  </span>
                 
                </div> */}

                <div>
                  <span>{t("PlaceOrderChild1.Deliverymethod")}</span>
                  <span className={styles['order-id']}>
                    {(() => {
                      const deliveryMethod = orderDetailData.product_order_items && orderDetailData.product_order_items[0]?.product_sku?.product?.delivery_method;
                      return deliveryMethod ? deliveryMethodOptionsMapper(t).find(item => item.value === deliveryMethod)?.label || deliveryMethod : '';
                    })()}
                  </span>
                  {/* <span>
                      {orderDetailData.order_items[0]?.product_sku?.product?.delivery_method}
                  </span> */}
                </div>
                <div>

                  {/* 如果没退款并且订单状态为已支付 */}
                  {(
                    !orderDetailData?.product_order?.product_order_refund && orderDetailData.product_order.product_order_status == 3
                  ) 
                     && (
                    <Button type="primary"
                      className={styles['save-address-btn']}
                      onClick={() => {
                        // 调用确认收货接口
                        Modal.confirm({
                          title: 'Confirm receipt',
                          content: 'Are you sure you want to confirm receipt?',
                          onOk: async () => {
                            const res = await saveOrderComplete({
                              product_order_id: orderDetailData.product_order.product_order_id,
                            });
                            if (res.code === 200) {
                              const orderResponse = await getOrderById(orderDetailData.product_order.product_order_id);
                              if (orderResponse.code === 200) {
                                message.success('Confirm receipt successfully');
                                setOrderDetailData(orderResponse.data);
                              }
                            } else {
                              message.error(res.message || '确认收货失败');
                            }

                          }
                        });
                      }}>{t("PlaceOrderChild1.ConfirmReceipt")}</Button>
                  )}
                  {/* 如果退款状态为已退款 */}
                  {(
                    orderDetailData?.product_order?.product_order_refund?.product_order_refund_status == 1 && orderDetailData.product_order.product_order_status == 3
                  ) 
                     && (
                      <span className={styles['order-refunded']}>{t("PlaceOrderChild1.Refunded")}</span>
                     )}
                </div>
              </div>
            )}

            {(!orderDetailData || isPendingPayment) && (
              <Button
                type="primary"
                disabled={(paymentMethod === 'stripe' && (!cardComplete || isPaymenting)) || false}
                className={styles['submit-order-btn']}
                onClick={isPendingPayment ? PayAgain : handleSubmitOrder}
              >
                {isPendingPayment ? 'Pay Now' : btnText}
              </Button>
            )}
          </div>
        </div>

      </div>
      {/* 支付提交 */}

      {/* 修改收货地址 */}
      <Modal
        title={isEditOrderAddress ? t('PlaceOrderChild1.EditShippingAddress') : t('PlaceOrderChild1.ShippingAddress')}
        closable={{ 'aria-label': 'Custom Close Button' }}
        width={isMobile ? '90%' : '60%'}
        maskClosable={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form form={formShippingAddress} layout="vertical">
          <Form.Item
            label="id"
            name="id"
            style={{ display: 'none' }}
          >
            <Input disabled />
          </Form.Item>

          <div className={styles['form-row2']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.FirstName')}
                name="first_name"
                rules={[{ required: true, message: t('membershipChild.PleaseInputYourFirstName') }]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.LastName')}
                name="last_name"
                rules={[{ required: true, message: t('membershipChild.PleaseInputYourLastName') }]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>

          <div className={styles['form-row2']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.Phone')}
                name="recipient_phone"
                rules={[{ required: true, message: t('membershipChild.PleaseInputYourPhone') }]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.Email')}
                name="email"
                rules={[
                  { required: true, message: t('membershipChild.PleaseInputYourEmail') },
                  { type: 'email', message: t('membershipChild.PleaseInputValidEmail') }
                ]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>

          <div className={styles['form-row2']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.Extension')}
                name="extension"
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.Address')}
                name="address"
                rules={[{ required: true, message: t('membershipChild.PleaseInputYourAddress') }]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>

          <div className={styles['form-row2']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.AptBuilding')}
                name="building"
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.ZipCode')}
                name="zip_code"
                rules={[{ required: true, message: t('membershipChild.PleaseInputYourZipCode')}]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>

          <div className={styles['form-row2']}>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.City')}
                name="city"
                rules={[{ required: true, message: t('membershipChild.PleaseInputYourCity')}]}
              >
                <Input />
              </Form.Item>
            </div>
            <div className={styles['form-col']}>
              <Form.Item
                label={t('membershipChild.State')}
                name="state"
                rules={[{ required: true, message: t('membershipChild.PleaseInputYourState') }]}
              >
                <Select>
                  {
                    StateList.map((item, index) => (
                      <Option value={item.value} key={index}>{item.label}</Option>
                    ))
                  }

                </Select>
              </Form.Item>
            </div>
          </div>

          <Form.Item
            label={t('Addresses.IsDefault')}
            name="is_default"
            valuePropName="checked"
          >
            <Checkbox></Checkbox>
          </Form.Item>
        </Form>
      </Modal>

        <ComponentDialog
          open={dialogOpen}
          mode={mode}
          info={currentInfo}
          onCancel={() => setDialogOpen(false)}
          onConfirm={() => handleConfirm()}
          onNavigate={() => onNavigate()}
        />


    </div>
  );
};

export default PlaceOrderChild; 